(function(window, document, $, undefined){

    'use strict';
    window.main = {};

    main.init = function() {
        main.test();
    }

    main.test =  function() {
        console.log('main.js has loaded successfully');
    }

    $(document).on( 'ready', main.init );

})(window, document, jQuery);
